export const USER_GUIDE_URL = process.env.VUE_APP_USER_GUIDE_URL || "https://guide.exiqtive.com";

export const FAIR_PAY_USER_GUIDE_URL = `${USER_GUIDE_URL}/fair-pay`;
